import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { PlanResponse, PlanRequest } from '../models';

@Injectable({ providedIn: 'root' })
export class PlanAdminService {
  private http    = inject(HttpClient);
  private base    = environment.apis.property;

  getPlans(): Observable<PlanResponse[]> {
    return this.http.get<PlanResponse[]>(`${this.base}/plans`);
  }

  createPlan(data: PlanRequest): Observable<PlanResponse> {
    return this.http.post<PlanResponse>(`${this.base}/admin/plans`, data);
  }

  updatePlan(id: string, data: PlanRequest): Observable<PlanResponse> {
    return this.http.put<PlanResponse>(`${this.base}/admin/plans/${id}`, data);
  }

  deletePlan(id: string): Observable<void> {
    return this.http.delete<void>(`${this.base}/admin/plans/${id}`);
  }
}
